export const UserEndpoints = {
  GetUsers: 'User/GetRecords',
  GetAccountSupplierAndSupplierBank: 'User/GetAccountSupplierAndSupplierBank',
  GetPaybevUserDetails: 'User/GetPaybevUserDetails',
  GetRoles: 'User/GetRoles',
  AddUser: 'User/CreateUser',
  EditUser: 'User/UpdateUser',
  GetUserAccountsSites: 'User/GetUserAccountsSites',
  GetUserAgencies: 'User/GetUserAgencies',
  UpdateProfileData: 'User/ProfileUpdate',
  // My Profile: a new mobile number only replaces the old one once a code texted to it is verified.
  PhoneChangeSend: 'PhoneChange/send',
  PhoneChangeResend: 'PhoneChange/resend',
  PhoneChangeVerify: 'PhoneChange/verify',
  UpdateUserProfile: 'User/UpdateUserProfile',
  UploadProfilePicture: 'User/ProfilePicture',
  DeleteUser: 'User/DeleteRecord',
  ReInviteUser: 'User/ReInviteUser',
  GetNotificationDetails: 'User/GetNotificationDetails',
  UpdateNotificationRecord: 'User/UpdateNotificationRecord',
  GetPrfileDetails: 'User/getprofile',
  UpdateProfile: 'User/updateprofile',
  UserSites: 'User/GetUserSites',
  GetUserAccounts: 'User/GetUserAccounts',
  GetRecordById: 'User/GetRecordById',
  GetAssignmentAndAgreementDate: 'User/GetAssignmentAndAgreementDate',
  UpdateProfilePicture: 'User/updateprofilepicture',
  MyAgreements: 'TermsAcceptance/MyAgreements',
  MyAgreement: 'TermsAcceptance/MyAgreement',
} as const;
